import { render, staticRenderFns } from "./thirdRiskRegisterTL.vue?vue&type=template&id=4d60d080"
import script from "./thirdRiskRegisterTL.vue?vue&type=script&lang=js"
export * from "./thirdRiskRegisterTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d60d080')) {
      api.createRecord('4d60d080', component.options)
    } else {
      api.reload('4d60d080', component.options)
    }
    module.hot.accept("./thirdRiskRegisterTL.vue?vue&type=template&id=4d60d080", function () {
      api.rerender('4d60d080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/timeline/thirdRiskRegisterTL.vue"
export default component.exports